import {axiosBffFetch, FetcherOptions} from '../../axios/axiosBffFetch';
import type {ApiResultVo} from '../../common/shared/api/nicolas/vo/ApiResultVo.interface';

/**
 * 최근 본 목록 삭제
 *
 * Origin: pageNicolasApi.deleteInvenRecent
 * API: DELETE /api/v1/inven/recent
 */
export async function deleteInvenRecent(
  series_uids: string,
  options?: FetcherOptions
): Promise<ApiResultVo> {
  const response = await axiosBffFetch(
    '/api/gateway/api/v1/inven/recent',
    {
      method: 'DELETE',
      params: {
        series_uids,
      },
    },
    options
  );
  return response.data;
}
